/*jslint node : true, nomen: true, plusplus: true, vars: true, eqeq: true,*/
/*
 * Copyright (c) 2014 Bimedia
 * Parc Éco 85-2 • 62 Impasse Paul Renaud, 85000 La Roche-sur-Yon.
 * All rights reserved.
 *
 * The copyright of this software is owned by Bimedia.
 * You may not use, copy or modify this software, except in
 * accordance with the license agreement you entered into with
 * Bimedia. For details see accompanying license terms.
 */
"use strict";

var Util = require('util');

function InternalError(message) {
    Error.call(this);
    if (typeof Error.captureStackTrace == 'function') {
        Error.captureStackTrace(this);
    }
    this.message = message;
}
Util.inherits(InternalError, Error);

function InvalidCredentialsError(message) {
    Error.call(this);
    if (typeof Error.captureStackTrace == 'function') {
        Error.captureStackTrace(this);
    }    
    this.message = message;
}
Util.inherits(InvalidCredentialsError, Error);

function InvalidArgumentError(message) {
    Error.call(this);
    if (typeof Error.captureStackTrace == 'function') {
        Error.captureStackTrace(this);
    }
    this.message = message;
}
Util.inherits(InvalidArgumentError, Error);

function InvalidContentError(message) {
    Error.call(this);
    if (typeof Error.captureStackTrace == 'function') {
        Error.captureStackTrace(this);
    }
    this.message = message;
}
Util.inherits(InvalidContentError, Error);

function ResourceNotFoundError(message) {
    Error.call(this);
    if (typeof Error.captureStackTrace == 'function') {
        Error.captureStackTrace(this);
    }
    this.message = message;
}
Util.inherits(ResourceNotFoundError, Error);

function NetworkError(message) {
    Error.call(this);
    if (typeof Error.captureStackTrace == 'function') {
        Error.captureStackTrace(this);
    }
    this.message = message;
}
Util.inherits(ResourceNotFoundError, Error);

function throwErrorModal (errorsArr, modalContent, modalButton) {
    console.log('throwErrorModal', errorsArr, modalContent, modalButton)
    modalContent.innerHTML = '';
    for (var i in errorsArr) {
        var element = document.createElement('LI')
        element.innerHTML = errorsArr[i]
        modalContent.appendChild(element)
    }
    errorsArr = [];
    modalButton.click();
}


/**
 * @class app
 */
module.exports = {	
	InternalError: InternalError,
	InvalidCredentialsError: InvalidCredentialsError,
	InvalidArgumentError: InvalidArgumentError,
	InvalidContentError: InvalidContentError,
    ResourceNotFoundError: ResourceNotFoundError,
    NetworkError: NetworkError,
    throwErrorModal: throwErrorModal
};


//////////////////
// WEBPACK FOOTER
// ./~/annonces-app-modules/config/Errors.js
// module id = 77
// module chunks = 0